import React, { useState } from 'react';
import { Box, Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import ContentCut from '@mui/icons-material/ContentCut';
import PaqueteriaAvatar from '../../paquetes/general/PaqueteriaAvatar';

function MenuItems({ paidItemsData, paidItems }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
        color="inherit"
      >
        Ver Item
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {paidItemsData ? (
          <>
            {paidItemsData.map((it) => (
              <Box key={it}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px', paddingX: 1 }}>
                  <PaqueteriaAvatar rate_provider={it.rate_provider} size="small" />
                  <Typography variant="subtitle2">{it.rate_provider}</Typography>
                  <Typography variant="subtitle2"> - {it.id}</Typography>
                </Box>
              </Box>
            ))}
          </>
        ) : (
          <>
            {paidItems.map((it) => (
              <Box key={it} sx={{ paddingX: 1 }}>
                <Typography>{it}</Typography>
              </Box>
            ))}
          </>
        )}
      </Menu>
    </>
  );
}

export default MenuItems;
